import { handleResponse, handleError, headerset } from "../apiUtils";
import { Budget } from "components/main/pianificazione/budgets/budgetsSlice";
import { FiltriBudgets } from "components/userPreference/userPreferenceSlice";


export function fetchBudgets(stagione_id:number) {
    const url: string = process.env.API_URL + "/api/pianificazione/budgets/"+ stagione_id + "/";

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

export function fetchBudgetsCommerciali(stagione_id:number, commerciale_id:number) {
    const url: string = process.env.API_URL + "/api/pianificazione/budgets/"+ stagione_id + "/commerciale/" + commerciale_id + "/";

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

export function fetchBudgetsCommercialiMandatari(stagione_id:number, mandatario_id:number, commerciale_id?:number) {
    let url: string = process.env.API_URL + "/api/pianificazione/budgets/"+ stagione_id + "/mandatario/" + mandatario_id + "/";
    if (commerciale_id) {
        url += `?commerciale=${commerciale_id}`;
    }
    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

export function fetchBudgetsTecniche(stagione_id:number,tecniche?: number[]) {
    let url: string = process.env.API_URL + "/api/pianificazione/budgets/"+ stagione_id + "/tecnica/";
    if (tecniche && tecniche.length > 0) {
        const filtro_tecniiche =  tecniche.join(',')
        url += `?tecniche_selezionate=${filtro_tecniiche}`;
    }
    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

export function fetchBudgetsMandatari(stagione_id: number) {
    const url: string = process.env.API_URL + "/api/pianificazione/budgets/" + stagione_id + "/mandatario/";

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}